import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IDropdownModel } from "common/models/IDropdownModel";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import {
  ICirculationSettings,
  IEmailSettings,
  IFineSettings,
  IGeneralSettings,
  IHolidaySettings,
  ILibrary,
  ILibraryGridFilter,
  ILibraryGridModel,
  IMemberCardSettings,
  IReminderSettings,
} from "./types";
import { libraryView } from "../types/libraryView";

export const library = createQueryKeys("library", {
  list: (postModel: PostModel<ILibraryGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<ILibraryGridModel>>(
        endpoints.library.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () => api.get<ILibrary>(`${endpoints.library.getById}/${Id}`),
  }),

  getLibraryValues: () => ({
    queryKey: ["GetLibraryValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.library.getLibraryValues),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () => api.get<libraryView>(`${endpoints.library.view}/${Id}`),
  }),

  getGeneralSettings: (Id: string | number) => ({
    queryKey: ["GeneralSettings", Id],
    queryFn: () =>
      api.get<IGeneralSettings>(
        `${endpoints.library.getGeneralSettings}/${Id}`
      ),
  }),
  getGeneralSettingsByLibrary: () => ({
    queryKey: ["GeneralSettingsByLibrary"],
    queryFn: () =>
      api.get<IGeneralSettings>(endpoints.library.getGeneralSettingsByLibrary),
  }),

  getCirculationSettings: (Id: string | number) => ({
    queryKey: ["CirculationSettings", Id],
    queryFn: () =>
      api.get<ICirculationSettings>(
        `${endpoints.library.getCirculationSettings}/${Id}`
      ),
  }),

  getFineSettings: (Id: string | number) => ({
    queryKey: ["FineSettings", Id],
    queryFn: () =>
      api.get<IFineSettings>(`${endpoints.library.getFineSettings}/${Id}`),
  }),

  getHolidaySettings: (Id: string | number) => ({
    queryKey: ["HolidaySettings", Id],
    queryFn: () =>
      api.get<IHolidaySettings>(
        `${endpoints.library.getHolidaySettings}/${Id}`
      ),
  }),

  getEmailSettings: (Id: string | number) => ({
    queryKey: ["EmailSettings", Id],
    queryFn: () =>
      api.get<IEmailSettings>(`${endpoints.library.getEmailSettings}/${Id}`),
  }),

  getReminderSettings: (Id: string | number) => ({
    queryKey: ["ReminderSettings", Id],
    queryFn: () =>
      api.get<IReminderSettings>(
        `${endpoints.library.getReminderSettings}/${Id}`
      ),
  }),

  getMemberCardSettings: (Id: string | number) => ({
    queryKey: ["MemberCardSettings", Id],
    queryFn: () =>
      api.get<IMemberCardSettings>(
        `${endpoints.library.getMemberCardSettings}/${Id}`
      ),
  }),
});

